import React from 'react';
import { useTranslation } from 'react-i18next';

import { ApplicationView } from '@shared/enums';
import { isDefaultView } from '@shared/utils/applications';
import { ArrowDownIcon } from '@shared/icons/arrow-down';
import clsx from 'clsx';

type Props = {
  view: ApplicationView;
  isCollapsed: boolean;
  onClick: (v: boolean) => void;
};

export const AccordionApplicationCardItemsTitle = (props: Props) => {
  const { t } = useTranslation();

  const title = isDefaultView(props.view) ? 'needs' : 'letter';

  return (
    <div
      className="text-black-50 text-xxs mb-2 flex items-center cursor-pointer"
      onClick={() => props.onClick(!props.isCollapsed)}
    >
      <span>{t(title)}</span>
      <ArrowDownIcon width={12} height={24} className={clsx({ 'rotate-180': props.isCollapsed }, 'ml-2')} />
    </div>
  );
};
